import { Injectable } from '@angular/core';
declare var gtag;
@Injectable({
  providedIn: 'root',
})
export class PersonalAnalysticsService {
  constructor() {}
  // food
  analyticVisitPersonalFood() {
    gtag('event', 'diary_personal_food_visited', {
      event_category: 'Diary Events',
    });
  }
  analyticCreatePersonalFood() {
    gtag('event', 'diary_personal_food_created', {
      event_category: 'Diary Events',
    });
  }
  analyticEditPersonalFood() {
    gtag('event', 'diary_personal_food_edited', {
      event_category: 'Diary Events',
    });
  }
  analyticDeletePersonalFood() {
    gtag('event', 'diary_personal_food_deleted', {
      event_category: 'Diary Events',
    });
  }
  analyticAddPersonalFood() {
    gtag('event', 'diary_personal_food_added', {
      event_category: 'Diary Events',
    });
  }
  // package
  analyticVisitPersonalPackage() {
    gtag('event', 'diary_personal_package_visited', {
      event_category: 'Diary Events',
    });
  }
  analyticCreatePersonalPackage() {
    gtag('event', 'diary_personal_package_created', {
      event_category: 'Diary Events',
    });
  }
  analyticEditPersonalPackage() {
    gtag('event', 'diary_personal_package_edited', {
      event_category: 'Diary Events',
    });
  }
  analyticDeletePersonalPackage() {
    gtag('event', 'diary_personal_package_deleted', {
      event_category: 'Diary Events',
    });
  }
  analyticAddPersonalPackage() {
    gtag('event', 'diary_personal_package_added', {
      event_category: 'Diary Events',
    });
  }
  // fast calorier
  analyticAddSimpleFood() {
    gtag('event', 'diary_simple_food_calorie_added', {
      event_category: 'Diary Events',
    });
  }
}
